// extracted by mini-css-extract-plugin
export default {"modeLabel":"ModeLabel_modeLabel__OOXfR","modePractice":"ModeLabel_modePractice__BYEHv","modeAssesment":"ModeLabel_modeAssesment__XkavY"};